<template>
  <div class="page">
    <img class="head" src="./assets/fengxian/fengxian.png" alt="" />
    <div class="list">
        <div class="item" @click="gotoDetail(item)" v-for="(item,index) in dataList" :key="index">
            <div class="left">
                <div class="title">{{item.title}}</div>
                <div class="tip">点击进入</div>
            </div>
            <div class="right">
                <div class="img">
                    <img style="width:100%;height:100%" :src="item.image" alt="">
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
var wx = require("weixin-js-sdk");

export default {
  name: "Claim",
  components: {},
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      pageHeight: window.innerHeight,
      isLoading:false,
      noData:false,
      dataList:[],
      params:{
          pageNumber:1,
          pageSize:50,
          queryKey:''
      }
    };
  },
  watch: {},
  async mounted() {
      await this.getList()
  },
  beforeDestroy: function () {},
  methods: {
    gotoDetail(item) {
        // if(type == 1){
            // this.$router.push({
            //     name:'YanJiuDetail'
            // })
            wx.miniProgram.navigateTo({
              url:
                "/pages/fxdetail/fxdetail?iid=0" +
                "&url=" +
                encodeURIComponent(`${item.url}`) +
                "&from=1",
              success: function () {
                // window.history.go(-1);
              },
            });
        // }
    },
    async getList() {
      this.isLoading = true;
      this.params.accountId = this.publicData.id;
      let res = await this.$http.post("/api/article/getList", this.params);
      if (!res.code) {
        console.log("res", res);
        this.noData = false;
        if (this.params.pageNumber == 1) {
          this.dataList = [];
          if (!res.list.length) {
            this.noData = true;
          }
        }
        this.dataList = [...this.dataList, ...res.list];
      }
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  //   padding: 0.15rem;
  box-sizing: border-box;
  background: #e7fcee;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  .head {
    width: 100%;
  }
  .list{
      padding: 0.15rem;
      box-sizing: border-box;
      .item{
            // height: 1.3rem;
            background: #FFFFFF;
            border-radius: 0.1rem;
            display: flex;
            padding: 0.16rem;
            box-sizing: border-box;
            margin-bottom: 0.11rem;
            justify-content: space-between;
            .left{
              height: max-content;
                .title{
                    font-size: 0.14rem;
                    font-family: Alibaba PuHuiTi;
                    font-weight: 500;
                    color: #333333;
                    line-height: 0.24rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
                .tip{
                    font-size: 0.12rem;
                    font-family: Alibaba PuHuiTi;
                    font-weight: 400;
                    color: #319A77;
                    margin-top: 0.13rem;
                    padding: 0.03rem 0.1rem;
                    background: rgba(225, 251, 236, .5);
                    width: fit-content;
                }
            }
            .right{
                padding-left: 0.29rem;
                height: max-content;
                .img{
                    width: 1.1rem;
                    height: 0.68rem;
                    background: #E1FBEC;
                    border-radius: 0.1rem;
                    display: flex;
                }
            }
      }
  }
}
</style>
